// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/action/project-category-assignment/project-category-assignment.component.css
// module id = 619
// module chunks = 0